export const DEFAULT_AVAILABLE_RESPONSE = { available: false, message: null };

export const KILOMETERS = 'KILOMETERS';
export const MILES = 'MILES';
